import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import { CommentContent } from '@web/timeClock/modals/rows/CommentRow/commentRow.styles';
import CommentIconSvg from '@web/assets/svg/Icons/32/clock-note-icon.svg';

type Props = {
  comment: string;
};

const CommentRow = ({ comment }: Props) => (
  <ModalRow label={gettext('Comment')} icon={CommentIconSvg}>
    <CommentContent>
      <Text14 themeColor={ThemeColorType.gray}>{comment}</Text14>
    </CommentContent>
  </ModalRow>
);

export default CommentRow;
